var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFullLayout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 59,
    viewBox: "0 0 72 59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Percorso",
    fill: "currentColor",
    stroke: "none",
    d: "M 63.557648 2 C 70.085602 2.195313 69.999947 5.893826 69.999947 10.697109 L 69.999947 24.225945 C 69.999947 29.029224 69.949692 33.025658 63.557648 32.923054 L 10.730763 32.923054 C 3.045125 32.998932 3 29.029224 3 24.225945 L 3 10.697109 C 3 5.893826 3.032116 2.158363 9.442304 2 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Percorso-copia",
    fill: "currentColor",
    stroke: "none",
    d: "M 15.9375 39 C 18.73344 39 21 41.266556 21 44.0625 L 21 51.9375 C 21 54.73344 18.73344 57 15.9375 57 L 8.0625 57 C 5.266559 57 3 54.73344 3 51.9375 L 3 44.0625 C 3 41.266556 5.266559 39 8.0625 39 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Percorso-copia-2",
    fill: "currentColor",
    stroke: "none",
    d: "M 64.9375 39 C 67.733437 39 70 41.266556 70 44.0625 L 70 51.9375 C 70 54.73344 67.733437 57 64.9375 57 L 57.0625 57 C 54.26656 57 52 54.73344 52 51.9375 L 52 44.0625 C 52 41.266556 54.26656 39 57.0625 39 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Percorso-copia-3",
    fill: "currentColor",
    stroke: "none",
    d: "M 39.9375 39 C 42.73344 39 45 41.266556 45 44.0625 L 45 51.9375 C 45 54.73344 42.73344 57 39.9375 57 L 32.0625 57 C 29.26656 57 27 54.73344 27 51.9375 L 27 44.0625 C 27 41.266556 29.26656 39 32.0625 39 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFullLayout);
export default __webpack_public_path__ + "static/media/ic-full-layout.22fa75f9913f890ab0011e4c47f8fa60.svg";
export { ForwardRef as ReactComponent };